import { default as Img } from 'next/image'
import { Image } from 'semantic-ui-react'
import Link from 'next/link'

import styles from './style.module.css'
import DefaultCompany from '@assets/default_company.png'

// const Img = () => null

export default function Logo({
  image,
  companyName,
  wrapperStyle,
  large,
  companyId,
  imgHeight,
  imgWidth,
  nameStyle,
}) {
  const imgStyle = { height: '70px', width: 'auto' }

  let coNameStyle

  if (large && !nameStyle) {
    coNameStyle = { fontSize: '24px', lineHeight: '32px' }
  } else if (nameStyle) {
    coNameStyle = nameStyle
  }

  const companyPageUrl = `/company/${companyId}`

  const handleClick = (e) => {
    e.stopPropagation()
  }

  if (companyId && companyId !== '-99' && companyId !== '0') {
    if (image) {
      return (
        <Link href={companyPageUrl} passHref>
          <div
            className={`${styles.logoWrapper} ${styles.inhouseCo}`}
            style={wrapperStyle}
            onClick={handleClick}
          >
            <Image
              alt="right"
              className={styles.coImage}
              src={image ?? DefaultCompany}
              height={imgHeight ?? imgStyle.height}
              width={imgWidth ?? imgStyle.height}
              objectFit="contain"
            />
            <div className={styles.coName} style={coNameStyle}>
              {companyName}
            </div>
          </div>
        </Link>
      )
    } else {
      return (
        <Link href={companyPageUrl} passHref>
          <div
            className={`${styles.logoWrapper} ${styles.inhouseCo}`}
            style={wrapperStyle}
            onClick={handleClick}
          >
            <Img
              alt="right"
              className={styles.coImage}
              src={DefaultCompany}
              height={imgHeight ?? imgStyle.height}
              width={imgWidth ?? imgStyle.height}
              objectFit="contain"
            />
            <div className={styles.coName} style={coNameStyle}>
              {companyName}
            </div>
          </div>
        </Link>
      )
    }
  }

  if (image) {
    return (
      <div
        className={styles.logoWrapper}
        style={{ ...wrapperStyle, cursor: 'unset' }}
      >
        <Image
          alt="right"
          className={styles.coImage}
          src={image ?? DefaultCompany}
          height={imgHeight ?? imgStyle.height}
          width={imgWidth ?? imgStyle.height}
          objectFit="contain"
        />
        <div className={styles.coName} style={coNameStyle}>
          {companyName}
        </div>
      </div>
    )
  } else {
    let renderThis = DefaultCompany

    if (image?.length) {
      renderThis = image
    }

    return (
      <div
        className={styles.logoWrapper}
        style={{ ...wrapperStyle, cursor: 'unset' }}
      >
        <Img
          alt="right"
          className={styles.coImageDefault}
          src={renderThis}
          height={imgHeight ?? imgStyle.height}
          width={imgWidth ?? imgStyle.height}
          objectFit="contain"
        />
        <div className={styles.coName} style={coNameStyle}>
          {companyName}
        </div>
      </div>
    )
  }
}
